<template>
	<div class="d-flex">
		<img
			v-if="imgSrc"
			class="mr-4 ao-preview-photo"
			:src="imgSrc"
			alt=""
		>
	</div>
</template>

<script>
export default {
	name: 'PopupPhoto',

	props: {
		imgSrc: {
			type: String,
		},
	},
}
</script>

<style lang="scss">
.ao-preview-photo {
	max-width: 100%;
	max-height: 600px;
	width: 100%;
}
</style>
